<template>
    <div
        class="ppv2-flex ppv2-items-center ppv2-px-4 ppv2-py-2.5"
        style="background-color: #0c1322; border-bottom: 1px solid #1e293b"
    >
        <TrafficLights />
        <AddressBar :url="displayUrl" />
    </div>
</template>

<script>
import TrafficLights from './TrafficLights.vue'
import AddressBar from './AddressBar.vue'

export default {
    name: 'BrowserChrome',
    components: {
        TrafficLights,
        AddressBar,
    },
    props: {
        // Pass selectedWidget down from your main app/page
        selectedWidget: {
            type: Object,
            default: () => null,
        },
        iframeSrc: {
            type: String,
            default: null,
        },
        urlFront: {
            type: String,
            default: '',
        },
    },
    computed: {
        displayUrl() {
            return this.iframeSrc || this.selectedWidget?.url_front || this.urlFront || ''
        },
    },
}
</script>
